<template>
  <section>
    <div
      id="card-element"
      ref="cardElement"
      class="form-control form-control-sm"
    />
    <b-alert
      :show="activeError"
      variant="danger"
      class="p-1 my-1"
    >
      Error: {{ errorText }}
    </b-alert>
  </section>
</template>

<script>
import { loadStripe } from '@stripe/stripe-js'
import AccountsService from '@/api/client/accounts.service'
import notification from '@/mixins/toastification'

export default {
  mixins: [notification],
  props: {
    stripePublicKey: {
      type: String,
      default: '',
    },
    depositModel: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      activeError: false,
      paymentLoading: false,
      errorText: '',
      stripe: null,
      card: null,
    }
  },
  async mounted() {
    this.stripe = await loadStripe(this.stripePublicKey)
    const elements = this.stripe.elements()
    this.card = elements.create('card', {
      hidePostalCode: true,
      style:
          {
            base: {
              lineHeight: '2',
              fontSize: '16px',
              color: '#6e6b7b',
            },
          },
    })
    this.card.mount(this.$refs.cardElement)
  },
  methods: {
    async paymentSubmit() {
      if (this.depositModel.amount > 0 && this.depositModel.message !== '') {
        this.paymentLoading = true
        const { accountId } = this.$route.params
        try {
          const createPaymentResponse = await AccountsService.createPaymentIntent(this.depositModel, accountId)
          if (createPaymentResponse.inserted) {
            const { transactionId } = createPaymentResponse
            const { clientSecretKey } = createPaymentResponse
            this.stripe.confirmCardPayment(clientSecretKey, {
              payment_method: {
                card: this.card,
              },
            }).then(async results => {
              if (results.paymentIntent) {
                const confirmPaymentResponse = await AccountsService.confirmPaymentIntent(transactionId, accountId)
                if (confirmPaymentResponse) {
                  this.success('Confirmed deposit')
                  this.$router.push(`/${accountId}/account/balance`)
                }
              } else if (results.error) {
                this.activeError = true
                this.errorText = `${results.error.message}`
              }
              this.paymentLoading = false
            })
          } else {
            this.activeError = true
            this.errorText = `${createPaymentResponse.message}`
            this.paymentLoading = false
          }
        } catch (error) {
          this.activeError = true
          this.errorText = `${error.message}`
          this.paymentLoading = false
        }
      } else {
        this.activeError = true
        this.errorText = 'Amount must be positive'
        this.paymentLoading = false
      }
    },
  },
}
</script>
